// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getOrder as customGetOrder } from "@ces/App/Services/OrderService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getOrder } from "@insite/client-framework/Services/OrderService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";

export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    try {
        props.apiResult =
            (props as any).parameter?.isCustom === false
                ? await getOrder(props.apiParameter)
                : await customGetOrder(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 404 || error.status === 403)) {
            props.dispatch({
                type: "Data/Orders/FailedToLoadOrder",
                orderNumber: props.parameter.orderNumber,
                status: error.status,
            });
            return false;
        }
        throw error;
    }
};
replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
